"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    VisibleAreaContext: function() {
        return VisibleAreaContext;
    },
    VisibleAreaProvider: function() {
        return VisibleAreaProvider;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _IframePageInfoContext = require("./IframePageInfoContext");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const VisibleAreaContext = /*#__PURE__*/ (0, _react.createContext)({});
const VisibleAreaProvider = (param)=>{
    let { children } = param;
    const { pageInfo, inIframe } = (0, _react.useContext)(_IframePageInfoContext.IframeResizerContext);
    const visibleArea = (0, _react.useMemo)(()=>!inIframe ? undefined : {
            bottom: Math.min(pageInfo.scrollTop - pageInfo.offsetTop + pageInfo.clientHeight, pageInfo.iframeHeight),
            top: Math.max(pageInfo.scrollTop, 0),
            right: Math.min(pageInfo.scrollLeft - pageInfo.offsetLeft + pageInfo.clientWidth, pageInfo.iframeWidth),
            left: Math.max(pageInfo.scrollLeft, 0)
        }, [
        inIframe,
        pageInfo
    ]);
    return /*#__PURE__*/ _react.default.createElement(VisibleAreaContext.Provider, {
        value: {
            visibleArea
        }
    }, children);
};

//# sourceMappingURL=VisibleAreaContext.js.map